<!--
 * @Author: LiZhiWei
 * @Date: 2026-01-21 08:51:46
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2026-02-02 10:41:37
 * @Description: 
-->
<template>
  <section
    ref="aboutRef"
    class="about-section transition-all duration-1000 ease-out bg-white py-120px lt-sm:pt-40px lt-sm:pb-120px"
    :class="[isAboutVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-50px']"
  >
    <div class="inner-container landing-container lt-sm:px-32px">
      <!-- Top Section -->

      <!-- Bottom Section -->
      <div
        class="bottom-section flex items-stretch justify-between gap-64px lt-sm:flex-col lt-sm:mt-120px lt-sm:gap-56px"
      >
        <!-- Left Content -->
        <div class="left-content flex-1 flex flex-col gap-40px lt-sm:items-center lt-sm:gap-56px">
          <div
            class="title-wrapper pf-sc-semibold flex items-center w-264px whitespace-nowrap lt-sm:w-full lt-sm:justify-center"
          >
            <span class="brand-text font-s-36px text-primary lt-sm:font-s-48px">绘家科技</span>
            <span class="who-is-text font-s-36px text-#000000 lt-sm:font-s-48px">是谁</span>
          </div>
          <div class="company-desc-wrapper flex flex-col gap-32px">
            <div
              class="desc-text pf-sc-regular font-s-16px text-#000000 lh-26px lt-sm:font-s-26px lt-sm:lh-42px"
            >
              海南绘家科技有限公司矢志成为优秀的智慧社区整体解决方案供应商。公司以技术研发为核心，深耕物业行业，致力于借助智能硬件、互联网、物联网、云计算、大数据分析、人工智能等技术推动物业服务企业发展线上线下社区服务业，实现数字化、智能化、精细化的管理与服务提升物业服务品质，提高企业管理效率，助力智慧社区建设。
            </div>
            <div
              class="desc-text pf-sc-regular font-s-16px text-#000000 lh-26px lt-sm:font-s-26px lt-sm:lh-42px"
            >
              目前，公司拥有绘管家物业综合管理云平台、绘服务业主在线服务平台、绘享云大数据分析平台、智慧值守停车场、人脸识别门禁、智能监控、智能充电桩、远程抄表、机械环保作业设备、地勤指挥中心、物业综合配套等全方位的智慧物业和智慧社区解决方案及服务体系。
            </div>
          </div>
          <button
            class="consult-btn bg-#1A73E8 text-white px-15px py-16px w-268px rounded-8px flex items-center justify-between hover:opacity-80 transition-colors cursor-pointer border-none lt-sm:hidden"
            @click="openConsultation"
          >
            <span class="btn-text pf-sc-regular font-s-16px">立即咨询</span>
            <div class="btn-icon i-custom-arrow-right wh-18px" aria-hidden="true"></div>
          </button>
        </div>
        <!-- Right Video Card -->
        <div
          class="video-card play-box flex-1 flex items-center justify-center rounded-16px shadow-sm relative overflow-hidden lt-sm:min-h-420px lt-sm:flex-shrink-0"
        >
          <!-- 极致毛玻璃圆盘 -->
          <button
            class="play-circle wh-84px rounded-full flex items-center justify-center cursor-pointer hover:scale-110 transition-transform duration-300 lt-sm:wh-96px hover:lt-sm:scale-100 border-none p-0"
            aria-label="播放企业宣传视频"
            @click="playVideo"
          >
            <i class="play-icon i-custom-play wh-84px" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <div>
        <!-- <div class="stats-title pf-sc-semibold font-s-36px lh-normal hidden lt-sm:font-s-48px lt-sm:text-center lt-sm:mt-72px">
          <span class="stats-highlight text-primary">800+家</span>
          <span>小区已经选择绘家</span>
        </div> -->
        <div
          class="stats-grid flex justify-between mt-72px lt-sm:grid lt-sm:gap-x-132px lt-sm:gap-y-36px lt-sm:grid-cols-2 lt-sm:px-58px lt-sm:mt-72px"
        >
          <div v-for="(item, index) in stats" :key="index">
            <div class="stat-label pf-sc-regular font-s-14px text-#384146 mb-8px lt-sm:font-s-24px">
              {{ item.label }}
            </div>
            <div
              class="stat-value d-din-pro-600-semibold font-s-38px text-main lh-38px lt-sm:font-s-56px lt-sm:lh-56px"
            >
              {{ item.value }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Video Modal -->
    <Teleport to="body">
      <div
        v-if="isVideoPlaying"
        class="fixed inset-0 z-999 flex items-center justify-center bg-black/80 backdrop-blur-sm animate-fade-in"
        role="dialog"
        aria-modal="true"
        aria-label="视频播放器"
        @click.self="closeVideo"
      >
        <button
          class="absolute top-30 right-10% lt-sm:right-20px lt-sm:top-20px text-white/80 hover:text-white transition-colors cursor-pointer bg-transparent border-none p-0"
          aria-label="关闭视频"
          @click="closeVideo"
        >
          <i class="i-ep-close wh-48px lt-sm:wh-48px" aria-hidden="true"></i>
        </button>
        <div
          class="relative w-full max-w-1000px mx-20px aspect-video bg-black overflow-hidden shadow-2xl"
        >
          <video
            src="https://cloud.video.taobao.com/play/u/1057773/p/1/d/sd/e/6/t/1/550775295418.mp4?auth_key=YXBwX2tleT04MDAwMDAwMTImYXV0aF9pbmZvPXsidGltZXN0YW1wRW5jcnlwdGVkIjoiZTQ1OGVhOGExMDdkODQ5MGE2ODBkZDNlYTk5YzI0MDkifSZkdXJhdGlvbj0mdGltZXN0YW1wPTE3Njg4NzM3MTg="
            controls
            autoplay
            class="w-full h-full object-contain"
            aria-label="企业宣传视频"
          ></video>
        </div>
      </div>
    </Teleport>
  </section>
</template>

<script setup lang="ts">
  const stats = [
    { label: '遍布城市', value: '30+' },
    { label: '服务客户', value: '300+' },
    { label: '管理小区', value: '800+' },
    { label: '城市合伙人', value: '3+' },
    { label: '房屋', value: '50w+' },
    { label: '账单资金', value: '15亿/年' },
  ]

  const { openConsultation } = useConsultation()

  const isVideoPlaying = ref(false)
  const aboutRef = ref<HTMLElement | null>(null)
  const { isVisible: isAboutVisible } = useScrollReveal(aboutRef)
  const playVideo = () => {
    isVideoPlaying.value = true
  }

  const closeVideo = () => {
    isVideoPlaying.value = false
  }
</script>

<style scoped>
  .play-box {
    background-image: url('~/assets/images/play-bg.jpg');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
  }

  .play-circle {
    background: linear-gradient(135deg, rgba(161, 158, 158, 0.2) 0%, rgba(43, 41, 41, 0.25) 100%);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    border: 1px solid rgba(255, 255, 255, 0.8);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  }
</style>
